import NumberInput from 'stories/FormInputs/Number/Number'

import { typeUtils } from 'types'
import {
  getFormItemErrors,
  getFormItemLabel,
  getGenericFormItemDefaultValue,
} from './_propGetters'
import {
  getMaxValueRule,
  getMinValueRule,
  getRequiredRule,
} from './_validationProps'

const Component = NumberInput

const getDefaultValue = fieldProps =>
  getGenericFormItemDefaultValue(fieldProps, '')

const getDecimalStep = (decimalPlaces = 0) => {
  if (!decimalPlaces) return 1
  const denominator = [...Array(decimalPlaces).keys()].reduce(
    (prev, curr) => prev + '0',
    '1',
  )
  return 1 / Number(denominator) // ex : for 2 decimal places it will return 0.01
}

const getProps = fieldProps => ({
  ...fieldProps,
  name: fieldProps.slug,
  label: getFormItemLabel(fieldProps),
  // input props
  separateLabel: true,
  autoFill: false,
})

const getControlledProps = (fieldProps, controllerProps, defaultValue) => ({
  ...controllerProps.field,
  type: typeUtils.getMostSpecificType(fieldProps),
  label: getFormItemLabel(fieldProps),
  decimal: Boolean(fieldProps?.decimal_places),
  step: getDecimalStep(fieldProps?.decimal_places),
  // input props
  separateLabel: true,
  autoFill: false,
  errors: getFormItemErrors(controllerProps),
})

const getValidationRules = (fieldProps, options) => ({
  ...getRequiredRule(fieldProps, options),
  ...getMinValueRule(fieldProps),
  ...getMaxValueRule(fieldProps),
})

export const numberInput = {
  Component,
  getProps,
  getControlledProps,
  getValidationRules,
  getDefaultValue,
}
